import { messages } from "../helpers/messages";

export const loginFormValidations = (
  fieldValues,
  temp,
  values,
  setValues,
  setErrors
) => {
  if ("username" in fieldValues) {
    temp.username = fieldValues.username ? "" : messages.errors.user_req;
  }
  if ("password" in fieldValues) {
    temp.password = fieldValues.password ? "" : messages.errors.pass_req;
  }

  setErrors({
    ...temp,
  });
  if (fieldValues === values) return Object.values(temp).every((x) => x === "");
};
